/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const GetFieldData = data => {
  return new Promise(function request(resolve) {
    // Build query parameters
    const queryParams = [];
    if (data.formtask_ID) {
      queryParams.push(`formtask_ID=${data.formtask_ID}`);
    }
    if (data.interviewtask_ID) {
      queryParams.push(`interviewtask_ID=${data.interviewtask_ID}`);
    }
    
    // Construct URL with query parameters if they exist
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const url = `${maverickPortalApiEndPoint.getFieldOverview.url}/${data.user_ID}/${data.project_ID}${queryString}`;
    
    maverickPortalhttp
      .makeRequest(
        url,
        maverickPortalApiEndPoint.getFieldTaskCompleteCount.methodType
      )
      .then(response => {
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { GetFieldData };
